import { EMPTY, of } from 'rxjs';
import { expand, map, mergeMap, reduce, skip } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { MarkoutAction } from '../markout.action';

type IDependencies = IClientApiDependencySegment;

const PAGE_LIMIT = 1000;

interface IPage {
  symbols: string[];
  skip: number;
  isLastPage: boolean;
}

export const loadFormSymbolsEpic: IEpic<{}, IDependencies> = (action$, _, { api }) =>
  action$.pipe(
    isTypeOfAndGetPayload(MarkoutAction.loadFormSymbols.started),
    mergeMap((params) => {
      const fetchPage = (pageSkip: number) =>
        api.getServerClientSymbolList({ serverId: params.serverId, limit: PAGE_LIMIT, skip: pageSkip }).pipe(
          map(({ symbols }): IPage => ({
            symbols: symbols.map((symbol) => symbol.name),
            skip: pageSkip + PAGE_LIMIT,
            isLastPage: symbols.length < PAGE_LIMIT,
          })),
        );

      return of({ symbols: [], skip: 0, isLastPage: false } as IPage).pipe(
        expand((page) => (page.isLastPage ? EMPTY : fetchPage(page.skip))),
        skip(1),
        reduce((all, page) => all.concat(page.symbols), [] as string[]),
        map((symbols) => MarkoutAction.loadFormSymbols.done({ params, result: { symbols } })),
        catchApiError((error) => [
          MarkoutAction.loadFormSymbols.failed({ params, error }),
          createApiErrorNotification(error),
        ]),
      );
    }),
  );
